import { Component, OnDestroy, OnInit } from '@angular/core';
import { catchError, filter, take, tap } from 'rxjs/operators';
import { CheckoutDeliveryAddressFacade } from '@spartacus/checkout/base/root';
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { OrderFacade } from '@spartacus/order/root';
import { GenDelegoTransactionStatus } from 'src/app/generac/enums/delego-transaction-status.enum';
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';
import { GenLaunchDialogService } from 'src/app/generac/services/launch-dialog.service';
import { GenOrderService } from 'src/app/generac/services/order.service';
import { GenDelegoService } from 'src/app/generac/services/delego.service';
import { environment } from 'src/environments/environment';

declare var xdm: any;

@Component({
    selector: 'gen-checkout-delego',
    templateUrl: './checkout-delego.component.html',
    standalone: false
})
export class GenCheckoutDelegoComponent implements OnInit, OnDestroy {
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  closeReason: string;

  private formattedDeliveryAddress: string;
  private cartNumber: string;
  private socket: any;
  constructor(
    protected orderFacade: OrderFacade,
    private delegoService: GenDelegoService,
    private checkoutDeliveryAddressFacade: CheckoutDeliveryAddressFacade,
    private activeCartFacade: ActiveCartFacade,
    private launchDialogService: GenLaunchDialogService,
    private globalMessageService: GlobalMessageService,
    private baseStoreService: GenBaseStoreService,
    private customOrderService: GenOrderService,
  ) {
  }

  ngOnInit(): void {
    this.subscribeToSecretParams();
    this.subscribeToDeliveryAddressState();
    this.subscribeToActiveCart();
  }

  ngOnDestroy(): void {
    this.closeModal();
    this.socket.removeEventListener();
  }

  closeModal(): void {
    this.launchDialogService.closeDialog(this.closeReason || 'destroy', 'PAY_BY_DELEGO');
  }

  private subscribeToSecretParams(): void {
    this.delegoService
      .getSecretParams()
      .pipe(
        take(1),
        tap((res) => this.generateIframe(res))
      ).subscribe();
  }

  private generateIframe(params: any): void {
    const iframe: any = document.getElementById('delegoFrame');
    this.socket = new xdm.Socket({
      isHost: true,
      frameId: iframe?.id,
      remoteDomain: environment.delegoRemoteDomain,
      onMsg: this.onPartnerMessage.bind(this),
    });
    this.baseStoreService.currentSite$
      .pipe(take(1))
      .subscribe(siteId => iframe.src = `${environment.delegoRemoteDomain}/DelegoCE/?sorg=B2B01&sec1=${params.sec1}&sec2=${params.sec2}&siteId=${siteId}`)
  }

  private onPartnerMessage(params: any) {
    if (params === 'CLOSE') return;
    this.isLoading$.next(true);
    const response = JSON.parse(params);
    const requestBody = {
      accountHolderName: response.CardHolder,
      cardType: {code: response.CardType},
      expiryMonth: response.CardExpirationDate.slice(0, 2),
      expiryYear: response.CardExpirationDate.slice(3),
      cardNumber: response.CardToken,
      subscriptionId: response.CardToken,
      billingAddress: this.formattedDeliveryAddress,
    };
    this.delegoService
      .sendPaymentDetails(this.cartNumber, requestBody)
      .pipe(
        take(1),
        catchError((error) => {
          this.isLoading$.next(false);
          this.closeModal();
          this.globalMessageService.add(
            {
              key: 'checkoutReview.errorPlacingOrder',
            },
            GlobalMessageType.MSG_TYPE_ERROR
          );
          return throwError(() => error);
        })
      ).subscribe(response => {
      if (response.transactionStatusDetails === GenDelegoTransactionStatus.SUCCESS) {
        this.isLoading$.next(false);
        this.closeReason = 'placeOrder';
        this.closeModal();
        this.customOrderService.placeOrder(true, true);
      }
    })
  }

  private subscribeToDeliveryAddressState(): void {
    this.checkoutDeliveryAddressFacade
      .getDeliveryAddressState()
      .pipe(
        take(1),
        tap((address: any) => (this.formattedDeliveryAddress = address?.data))
      )
      .subscribe();
  }

  private subscribeToActiveCart(): void {
    this.activeCartFacade
      .getActive()
      .pipe(
        filter(Boolean),
        take(1),
      ).subscribe((cart: Cart) => this.cartNumber = cart?.code);
  }
}
